/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {NgModule} from '@angular/core';
import {BoardAffiliationInformationService} from './board-affiliation-information.service';

@NgModule({
    providers: [
        BoardAffiliationInformationService
    ]
})
export class BoardAffiliationInformationModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/board/information/board-affiliation-information.module.ts